// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t3-2";
export var container = "_t3-4";
export var dismissButton = "_t3-3";
export var hasPaddingBottom = "_t3-6";
export var last = "_t3-e";
export var scrollbarThumb = "_t3-c";
export var scrollbarTrack = "_t3-b";
export var selected = "_t3-9";
export var spin = "_t3-1";
export var spinning = "_t3-0";
export var suggestionItem = "_t3-d";
export var suggestionsPanel = "_t3-5";
export var tonePill = "_t3-8";
export var tonesContainer = "_t3-7";
export var unselected = "_t3-a";